<template>
    <div class="kt-empty">
        <i v-if="icon && icon.includes('fas')" :class="['fa-3x', 'text-muted', icon]"></i>
        <img v-else-if="icon && icon.includes('assets')" :src="icon" alt="logo" />
        <div class="kt-empty-title">{{ title }}</div>
        <div class="kt-empty-subtitle">
            {{ subtitle }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: () => {
                return ""
            }
        },
        subtitle: {
            type: String,
            default: () => {
                return ""
            }
        },
        icon: {
            type: String,
            default: () => {
                return "fas fa-user"
            }
        }
    },
    computed: {

    },
    methods: {
        //Preparato per diversi tag da utilizzare per le icone
        getIconClass() {
            if (!this.icon) return "";

            if (this.icon.includes("fas")) {
                return `<i class="${this.icon} fa-3x text-muted mb-3"></i>`;
            }

            if (this.icon.includes("mdi")) {
                return `<i class="${this.icon} mdi-36px text-muted mb-3"></i>`;
            }

            return "";
        }
    }
}
</script>

<style lang="scss" scoped>
.kt-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* grigio chiaro */
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    text-align: center;
    color: #6c757d;
    background-color: rgb(248, 248, 248);
    border-radius: 15px;
    border: 2px dashed #c5c5c5;
    padding-top: 3rem;
    padding-bottom: 3rem;
    margin-left: 7%;
    margin-right: 7%;
    margin-top: 20px;
}

.kt-empty-icon {
    font-size: 36px;
    color: #d1d3e0;
    margin-bottom: 16px;
}

.kt-empty-title {
    font-size: 20px;
    font-weight: 600;
    color: #2b2f38;
    letter-spacing: -0.05em;
    margin-bottom: 8px;
}

.kt-empty-subtitle {
    font-size: 14px;
    color: #7e8299;
}
</style>